import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ConcursoProvaService } from 'src/app/services/concurso-prova.service'
import { TipoProva } from 'src/app/enums/tipo-prova'
import { ProvaFase, ProvaFaseLabel } from 'src/app/enums/prova-fase'

@Component({
  selector: 'app-acompanhamento-correcao',
  templateUrl: './acompanhamento-correcao.component.html',
  styleUrls: ['./acompanhamento-correcao.component.scss'],
})
export class AcompanhamentoCorrecaoComponent implements OnInit {
  idConcurso!: number
  dados: any = null
  loading = true

  constructor(
    private route: ActivatedRoute,
    private concursoProvaService: ConcursoProvaService
  ) {}

  ngOnInit(): void {
    ;(this.route.parent?.params || this.route.params).subscribe(params => {
      this.idConcurso = params['id'] || params['idConcurso']
      if (this.idConcurso) this.carregar()
    })
  }

  carregar(): void {
    this.loading = true
    this.concursoProvaService.acompanhamentoCorrecao(this.idConcurso).subscribe({
      next: data => {
        this.dados = data
        this.loading = false
      },
      error: () => (this.loading = false),
    })
  }

  get provasFase1() {
    return (this.dados?.provas?.filter((p: any) => p.provaFase === 'FASE1') || [])
      .sort((a: any, b: any) => (a.provaOrdem ?? 0) - (b.provaOrdem ?? 0))
  }

  get provasFase2() {
    return (this.dados?.provas?.filter((p: any) => p.provaFase === 'FASE2') || [])
      .sort((a: any, b: any) => (a.provaOrdem ?? 0) - (b.provaOrdem ?? 0))
  }

  getNomeProva(tipoProva: string): string {
    return (TipoProva as any)[tipoProva]?.nome || tipoProva
  }

  getProgressoPercentual(ex: any): number {
    if (ex.totalInscricoes === 0) return 0
    return Math.round((ex.notasDigitadas / ex.totalInscricoes) * 100)
  }

  temEmpatesPendentes(prova: any): boolean {
    return prova.examinadores?.some((ex: any) => ex.possuiEmpate) || false
  }

  isUltimaProvaFase2(prova: any): boolean {
    if (prova.provaFase !== 'FASE2') return false
    const fase2 = this.provasFase2
    return fase2.length > 0 && fase2[fase2.length - 1].tipoProva === prova.tipoProva
  }

  isFaseConcluida(fase: string): boolean {
    if (fase === 'FASE1') return this.dados?.fase1Consolidada === true
    return this.dados?.fase2Consolidada === true
  }

  isFaseInativa(fase: string): boolean {
    if (fase === 'FASE1') return this.isFaseConcluida('FASE1')
    return !this.isFaseConcluida('FASE1') || this.isFaseConcluida('FASE2')
  }

  getStatusLabel(fase: string): string {
    if (this.isFaseConcluida(fase)) return 'Concluída'
    const provas = fase === 'FASE1' ? this.provasFase1 : this.provasFase2
    const todasProvasConcluidas = provas.length > 0 && provas.every((p: any) => p.concluido)
    if (todasProvasConcluidas) return 'Aguardando Consolidação'
    if (provas.some((p: any) => p.emAndamento)) return 'Em Andamento'
    if (fase === 'FASE2' && !this.isFaseConcluida('FASE1')) return 'Aguardando Fase 1'
    return 'Aguardando'
  }

  getStatusIcon(fase: string): string {
    if (this.isFaseConcluida(fase)) return 'check_circle'
    const provas = fase === 'FASE1' ? this.provasFase1 : this.provasFase2
    const todasProvasConcluidas = provas.length > 0 && provas.every((p: any) => p.concluido)
    if (todasProvasConcluidas) return 'pending_actions'
    if (provas.some((p: any) => p.emAndamento)) return 'hourglass_empty'
    if (fase === 'FASE2' && !this.isFaseConcluida('FASE1')) return 'lock'
    return 'schedule'
  }

  getStatusChipClass(fase: string): string {
    if (this.isFaseConcluida(fase)) return 'status-concluida'
    const provas = fase === 'FASE1' ? this.provasFase1 : this.provasFase2
    const todasProvasConcluidas = provas.length > 0 && provas.every((p: any) => p.concluido)
    if (todasProvasConcluidas) return 'status-aguardando-consolidacao'
    if (provas.some((p: any) => p.emAndamento)) return ''
    return 'status-bloqueada'
  }
}
